import { UserDocument } from '../lib/userDocuments.slice'
import { GroupByEnum, GroupedDocsEntry } from './helpers'
import { RowTypes, TableRow } from './TableRows'
import { Table, TableHeaderSort } from '@/ui'

export interface TableOptions {
  sortFn: (_a: UserDocument, _b: UserDocument) => number
  groupBy: GroupByEnum
}

interface TableHeaderConfig {
  sortBy: string | null
  title: string
}

interface DocumentsTableProps {
  columns: TableHeaderConfig[]
  documents: UserDocument[]
  hasSubDocuments: boolean
  onCheck?: (id: number, checked: boolean) => void
  rowType: RowTypes
  sort: (sortBy: string | null) => void
  sortAsc: boolean
  subDocuments?: GroupedDocsEntry[]
}

export const DocumentsTable = ({
  columns,
  documents,
  onCheck,
  rowType,
  sort,
  sortAsc,
  subDocuments,
  hasSubDocuments,
}: DocumentsTableProps) => {
  const getSortOrder = (sortAsc: boolean) => {
    return sortAsc ? TableHeaderSort.ASCENDING : TableHeaderSort.DESCENDING
  }
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          {columns.map(({ title, sortBy }) => (
            <Table.HeaderCell
              key={title}
              sortable={Boolean(sortBy)}
              onClick={() => sortBy && sort(sortBy)}
              sorted={getSortOrder(sortAsc)}
            >
              {title}
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {hasSubDocuments
          ? subDocuments?.flatMap((entry) =>
              entry.docs.map((doc: UserDocument) => (
                <TableRow
                  key={doc.id}
                  document={doc}
                  type={rowType}
                  onCheck={onCheck}
                />
              ))
            )
          : documents.map((doc) => (
              <TableRow
                key={doc.id}
                document={doc}
                type={rowType}
                onCheck={onCheck}
              />
            ))}
      </Table.Body>
    </Table>
  )
}
